export const formatNumber = (number) => {
    // Last 4 digits of number
    const trail = number.substr(number.length-4, 4)
    // Middle 3 digits of number
    const middle = number.substr(number.length-7, 3)
    // Starting 3 digits of the number
    const start = number.substr(number.length-10, 3)
    const countryCode = number.substr(0, number.length-10)
    return `${countryCode}-${start}-${middle}-${trail}`
}